// 216: spustí `fn(item, index)` pro každou položku, nejvýš `limit` naráz.
// Výsledky vrací v pořadí položek (ne v pořadí dokončení). `fn` by neměla
// vyhazovat — chyby ať vrací jako hodnotu (jinak Promise.all skončí první chybou).
export async function mapLimit(items, limit, fn) {
  const list = Array.from(items || []);
  const out = new Array(list.length);
  let next = 0;
  const worker = async () => {
    while (next < list.length) {
      const i = next++;
      out[i] = await fn(list[i], i);
    }
  };
  const n = Math.max(1, Math.min(limit || 1, list.length));
  await Promise.all(Array.from({ length: list.length ? n : 0 }, worker));
  return out;
}
